import { FC } from 'react'

import { Icon } from './types'

export const ClockIcon: FC<Icon> = ({ className }) => {
  return (
    <svg width="31" className={className} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7ZM7.63636 3.18182C7.63636 2.83036 7.35145 2.54545 7 2.54545C6.64855 2.54545 6.36364 2.83036 6.36364 3.18182V7C6.36364 7.24104 6.49982 7.46139 6.71541 7.56918L9.26086 8.84191C9.57521 8.99908 9.95746 8.87167 10.1146 8.55732C10.2718 8.24297 10.1444 7.86072 9.83004 7.70355L7.63636 6.60671V3.18182Z"
        fill="currentColor"
      />
    </svg>
  )
}
